export class CityDropdownController {
  constructor(controller) {
    this.controller = controller
  }

  // ========================================
  // 市区町村ドロップダウン
  // ========================================

  toggleCityDropdown(event) {
    event.stopPropagation()

    // 都道府県が選択されていない場合は何もしない
    if (!this.controller.selectedPrefecture) {
      return
    }

    this.controller.prefectureDropdownController.closePrefectureDropdown()

    // クリックされた要素から親wrapperを見つける
    const wrapper = event.currentTarget.closest('.company-search-form__wrapper--pc, .company-search-form__wrapper--sp')
    const dropdown = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityDropdown"]')

    if (dropdown) {
      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block'
      } else {
        dropdown.style.display = 'none'
      }
    }
  }

  closeCityDropdown() {
    // 両方のwrapperのドロップダウンを閉じる
    this.controller.cityDropdownTargets.forEach(dropdown => {
      dropdown.style.display = 'none'
    })
  }

  // ========================================
  // 市区町村データ取得
  // ========================================

  async loadCities(prefectureName) {
    if (!prefectureName) {
      return
    }

    try {
      // 政令指定都市と一般市区町村を取得（区ページは除外済み、enabledフラグ付き）
      const response = await fetch(`/api/prefecture/${encodeURIComponent(prefectureName)}/cities_with_major`)

      if (!response.ok) {
        this.showErrorMessage('市区町村の取得に失敗しました。もう一度お試しください。')
        return
      }

      const cities = await response.json()

      this.controller.cities = cities

      // 市区町村ボタンを生成
      this.renderCityButtons()
    } catch (error) {
      this.showErrorMessage('市区町村の取得中にエラーが発生しました。もう一度お試しください。')
    }
  }

  showErrorMessage(message) {
    // 両方のwrapperのcityButtonsContainerに対してエラーメッセージを表示
    this.controller.cityButtonsContainerTargets.forEach(container => {
      container.textContent = ''
      const errorDiv = document.createElement('div')
      errorDiv.className = 'company-search-form__dropdown-error'
      errorDiv.textContent = message
      container.appendChild(errorDiv)
    })
  }

  // ========================================
  // 市区町村リスト表示
  // ========================================

  renderCityButtons() {
    // 両方のwrapperのcityButtonsContainerに対して実行
    this.controller.cityButtonsContainerTargets.forEach(container => {
      container.textContent = ''
      this.renderCityButtonsInContainer(container)
    })
  }

  renderCityButtonsInContainer(container) {
    // 全市区町村を五十音順グループで表示
    this.renderCitiesByKana(container, this.controller.cities)
  }

  renderCitiesByKana(container, cities) {
    // 五十音順のグループ定義
    const kanaGroups = [
      { group: 'あ', kanas: ['ア', 'イ', 'ウ', 'エ', 'オ'] },
      { group: 'か', kanas: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'] },
      { group: 'さ', kanas: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'] },
      { group: 'た', kanas: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'] },
      { group: 'な', kanas: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'] },
      { group: 'は', kanas: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'] },
      { group: 'ま', kanas: ['マ', 'ミ', 'ム', 'メ', 'モ'] },
      { group: 'や', kanas: ['ヤ', 'ユ', 'ヨ'] },
      { group: 'ら', kanas: ['ラ', 'リ', 'ル', 'レ', 'ロ'] },
      { group: 'わ', kanas: ['ワ', 'ヲ', 'ン'] }
    ]

    const kanaGroupData = []

    kanaGroups.forEach(({ group, kanas }) => {
      const groupCities = cities.filter(city => {
        if (!city.yomi) return false
        const firstChar = city.yomi.slice(0, 1)
        return kanas.includes(firstChar)
      })

      if (groupCities.length > 0) {
        kanaGroupData.push({ kana: group, cities: groupCities })
      }
    })

    kanaGroupData.forEach((group) => {
      if (group.cities.length > 0) {
        const groupTitle = document.createElement('div')
        groupTitle.className = 'company-search-form__dropdown-city-group-title'
        groupTitle.textContent = `${group.kana}行`
        container.appendChild(groupTitle)

        const groupButtons = document.createElement('div')
        groupButtons.className = 'company-search-form__dropdown-city-group-buttons'

        group.cities.forEach(city => {
          const button = this.createCityButton(city)
          groupButtons.appendChild(button)
        })

        container.appendChild(groupButtons)
      }
    })
  }

  createCityButton(city) {
    const button = document.createElement('button')
    button.className = 'company-search-form__dropdown-button'
    button.type = 'button'
    button.textContent = city.name
    button.dataset.cityId = city.id
    button.dataset.cityName = city.name

    if (city.enabled) {
      button.dataset.action = 'click->refosumu--home-index--company-search-form#selectCity'
    } else {
      button.classList.add('disabled')
      button.disabled = true
    }

    return button
  }

  // ========================================
  // 市区町村選択
  // ========================================

  selectCity(event) {
    event.preventDefault()
    const button = event.currentTarget
    const cityId = button.dataset.cityId
    const cityName = button.dataset.cityName

    // クリックされたボタンから親wrapperを見つける
    const wrapper = button.closest('.company-search-form__wrapper--pc, .company-search-form__wrapper--sp')

    // 前回選択された市区町村ボタンのselectedクラスを削除
    const allButtons = wrapper.querySelectorAll('.company-search-form__dropdown-button')
    allButtons.forEach(btn => btn.classList.remove('selected'))

    // 新しく選択されたボタンにselectedクラスを追加
    button.classList.add('selected')

    // 選択状態を更新
    this.controller.selectedCity = cityId
    this.controller.selectedCityName = cityName

    // ドロップダウンを閉じる
    this.closeCityDropdown()

    // ドロップダウンを非表示にしてピル型ボタンを表示
    this.showCitySelectedPill(cityName, wrapper)
  }

  showCitySelectedPill(cityName, wrapper) {
    // テキストを非表示
    const cityText = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityText"]')
    if (cityText) {
      cityText.style.display = 'none'
    }

    // ピル型ボタンを表示
    const citySelectedPill = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="citySelectedPill"]')
    if (citySelectedPill) {
      citySelectedPill.style.display = 'flex'
    }

    // 市区町村名を設定
    const citySelectedText = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="citySelectedText"]')
    if (citySelectedText) {
      citySelectedText.textContent = cityName
    }

    // セレクトボックスの下矢印を非表示にし、アイコンをオレンジにするためクラス追加
    const cityInput = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityInput"]')
    if (cityInput) {
      cityInput.classList.add('company-search-form__select--has-pill')
      cityInput.classList.add('company-search-form__select--selected')
    }
  }

  hideCitySelectedPill(wrapper) {
    // ピル型ボタンを非表示
    const citySelectedPill = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="citySelectedPill"]')
    if (citySelectedPill) {
      citySelectedPill.style.display = 'none'
    }

    // テキストを表示
    const cityText = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityText"]')
    if (cityText) {
      cityText.style.display = ''
    }

    // セレクトボックスの下矢印を表示し、アイコンを元に戻すためクラス削除
    const cityInput = wrapper.querySelector('[data-refosumu--home-index--company-search-form-target="cityInput"]')
    if (cityInput) {
      cityInput.classList.remove('company-search-form__select--has-pill')
      cityInput.classList.remove('company-search-form__select--selected')
    }
  }

  clearCity(event) {
    event.stopPropagation()
    event.preventDefault()

    // クリックされたボタンから親wrapperを見つける
    const wrapper = event.currentTarget.closest('.company-search-form__wrapper--pc, .company-search-form__wrapper--sp')

    // 選択状態をリセット
    this.controller.selectedCity = null
    this.controller.selectedCityName = null

    // ピル型ボタンを非表示にしてドロップダウンを表示
    this.hideCitySelectedPill(wrapper)

    // ドロップダウン内の選択状態をリセット
    const allButtons = wrapper.querySelectorAll('.company-search-form__dropdown-button')
    allButtons.forEach(btn => btn.classList.remove('selected'))
  }
}
